import { createContext, useContext, useState } from "react";

const ScopeContext = createContext({ scope: "all", setScope: () => {} });

export function ScopeProvider({ children }) {
  const [scope, setScope] = useState("all");
  return <ScopeContext.Provider value={{ scope, setScope }}>{children}</ScopeContext.Provider>;
}

export const useScope = () => useContext(ScopeContext);
